import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';
import type { ProductManifest } from '../../api/types';
import type { ListState } from '../common/AsyncList';

/** A Wave 1 product and the package versions uploaded for deployment. */
export interface ProductVersions {
  productId: string;
  displayName: string;
  latestVersion: string;
  versionCount: number;
  lastUploadedAt: string;
}

/** Deployable products (schema-2 manifests) from GET /api/products. */
export function useProductVersions(): ListState<ProductVersions> {
  const q = useQuery({ queryKey: ['products'], queryFn: () => api<ProductManifest[]>('products') });
  return {
    loading: q.isLoading,
    error: q.error ? (q.error as Error).message : null,
    items: (q.data ?? []).map((p) => ({
      productId: p.productId,
      displayName: p.displayName,
      latestVersion: p.packageUploaded ? p.version : `${p.version} (package not uploaded)`,
      versionCount: 1,
      lastUploadedAt: '',
    })),
  };
}
